VjsAdmin.DistrictGroups = (function () {
    const selections = [];
    const me = {};
    me.groupsTable = $('#groups-table');
    me.platformId = me.groupsTable.attr('data-platform-id');
    me.districtJointGuid = me.groupsTable.attr('data-district-joint-guid');
    me.bulkDeleteMax = 500;
    me.selections = [];
    me.queryParams = {};

    me.groupsTableQueryParams = (params) => {
        const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
        myParams.search_term = $('.fixed-table-toolbar .search input').val();

        switch (me.queryParams.rostering_type) {
            case 'all':
            case null:
                delete myParams.rostering_type;
                break;
            default:
                myParams.rostering_type = me.queryParams.rostering_type;
                break;
        }

        return myParams;
    };

    me.init = () => {
        me.initTable();
        me.setupBulkEditGroups();
    };

    me.initTable = () => {
        me.groupsTable.bootstrapTable({
            ...VjsTable.tableDefaults(),
            table: '#groups-table',
            formatNoMatches() {
                return 'No groups in this district!';
            },
            showColumns: true,
            buttonsAlign: 'right',
            idField: 'group_id',
            toolbar: '#report-toolbar',
            sortName: 'group_id',
            queryParams: me.groupsTableQueryParams,
            clickToSelect: true,
            url: Slim.Router.pathFor('platforms.districts.groups.list.json', {
                platform_id: me.platformId,
                district_joint_guid: me.districtJointGuid,
            }),
            columns: [
                {
                    field: 'checkbox',
                    title: 'Delete',
                    checkbox: true,
                    visible: false,
                },
                {
                    title: 'Name',
                    field: 'name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Owner',
                    field: 'owner',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Shared?',
                    field: 'shared',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Bulk Uploaded?',
                    field: 'bulk_upload_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Rostering Type',
                    field: 'rostering_type',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    title: 'Rostering ID',
                    field: 'rostering_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: false,
                },
                {
                    title: '# Users',
                    field: 'number_of_users',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    visible: true,
                },
                {
                    title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                },
            ],
            onUncheckAll() {
                me.selections = [];
                me.updateSelectedGroupsCount();
            },
            updateUrl() {
                VjsTable.tableDefaults().updateUrl.call(this, {});
            },
            onPreBody(data) {
                VjsTable.tableDefaults().onPreBody.call(this, data);

                const thisTable = this;
                $('#search-rostering-type').off();
                $('#search-rostering-type').on('change', (e) => {
                    me.queryParams.rostering_type = e.currentTarget.value;
                    thisTable.updateUrl();
                    me.groupsTable.bootstrapTable('refresh');
                });
            },
            responseHandler(res) {
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, origRow) => {
                    // we're getting a UTC date from the DB... need to convert it to the groups timezone...?
                    const dateFormat = 'MM/DD/YYYY';
                    const timeagoArray = [];
                    const row = VjsAdmin.convertDateRow(origRow, dateFormat, timeagoArray);

                    row.checkbox = $.inArray(row.group_id, selections) !== -1;
                    row.is_active = row.active;

                    if (+row.active === 0) {
                        row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    } else {
                        row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    }

                    if (+row.shared === 1) {
                        row.shared = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    } else {
                        row.shared = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    }

                    if (row.bulk_upload_id >= 1) {
                        row.bulk_upload_id = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                    } else {
                        row.bulk_upload_id = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                    }

                    if (VjsAdmin.hasPermission('platforms.districts.groups.view')) {
                        const groupUrl = Slim.Router.pathFor('platforms.districts.groups.view', {
                            platform_id: me.platformId,
                            district_joint_guid: me.districtJointGuid,
                            group_id: row.group_id,
                        });
                        row.name = `<a class="group-link" href="${groupUrl}" data-group-id="${row.group_id}" >${row.name}</a>`;
                    }
                    if (row.owner_id && VjsAdmin.hasPermission('platforms.districts.licenses.users.view')) {
                        const ownerUrl = Slim.Router.pathFor('platforms.districts.licenses.users.view', {
                            platform_id: me.platformId,
                            district_joint_guid: me.districtJointGuid,
                            license_id: row.license_id,
                            user_id: row.owner_id,
                        });
                        row.owner = `<a href="${ownerUrl}">${row.owner_first_name} ${row.owner_last_name}</a>`;
                    }
                });
                return formattedResult;
            },
        });
    };

    me.setupBulkEditGroups = () => {
        if (VjsAdmin.hasPermission('platforms.districts.groups.bulk_edit.post')) {
            me.bulkEditButtons = $('<div class="columns columns-right btn-group float-right"></div>');
            me.bulkEditEnableButton = $(
                '<button class="btn btn-hollow-pink" type="button" name="refresh" aria-label="refresh" title="Enable Bulk Edit Mode"><i class="fa-regular fa-square-check" aria-hidden="true"></i> Enable Bulk Edit Mode</button>',
            );
            me.bulkEditEditButton = $(
                '<button class="btn btn-hollow-pink" type="button" name="refresh" aria-label="refresh" data-toggle="tooltip" data-placement="top" title="Select Groups to Bulk Edit, then click here to choose an action" style="display:none;">Bulk Edit <span class="selected-groups-count">0 Groups</span></button>',
            );
            me.bulkEditDoneButton = $(
                '<button class="btn btn-hollow-dark-gray" type="button" name="refresh" aria-label="refresh" title="Done" style="display:none;">Done</button>',
            );
            me.bulkEditEnableButton.on('click', me.enableBulkEditMode);
            me.bulkEditDoneButton.on('click', me.disableBulkEditMode);

            // when they click on the bulk edit button, show the modal
            me.bulkEditEditButton.on('click', () => {
                if (me.selections.length > 0) {
                    me.bulkEditEditButton.tooltip('hide');
                    $('#bulk-edit-action').val('').trigger('change');
                    me.bulkEditModal.modal({
                        backdrop: 'static',
                        keyboard: false,
                    });
                }
            });

            me.bulkEditButtons.append(me.bulkEditEnableButton);
            me.bulkEditButtons.append(me.bulkEditEditButton);
            me.bulkEditButtons.append(me.bulkEditDoneButton);

            const bulkEditGroupsForm = $('<div>').html($('#bulk-edit-groups-form-template').html());
            const saveButton = $(
                `<button type="button" class="btn btn-blue" data-dismiss="modal">Save Changes for <span class="selected-groups-count">${me.selections.length} Groups</span></button>`,
            );
            const cancelButton = $('<button type="button" class="btn btn-hollow-dark-gray" data-dismiss="modal">Cancel</button>');

            saveButton.on('click', (e) => {
                e.preventDefault();
                $('#bulk-edit-modal .modal-body .alert').remove();
                $('#bulk-edit-modal .modal-body input').removeClass('is-invalid').removeClass('is-valid');
                const action = $('#bulk-edit-action').val();
                const data = {};
                data.groups = me.selections;
                data.action = action;
                const errors = [];

                // validate form
                switch (action) {
                    case 'delete':
                        if ($('#bulk_edit_delete-yes').prop('checked') !== true) {
                            $('#bulk_edit_delete-yes').removeClass('is-valid').addClass('is-invalid');
                            errors.push('You must be TOTALLY sure!');
                        } else {
                            $('#bulk_edit_delete-yes').removeClass('is-invalid').addClass('is-valid');
                            data.sure = true;
                        }
                        break;
                    default:
                        errors.push('No option selected.');
                        break;
                }

                if (errors.length > 0) {
                    $.each(errors, (i, error) => {
                        $('#bulk-edit-modal .modal-body').prepend(
                            `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${error}</div>`,
                        );
                    });
                    return false;
                }
                $('body').css('cursor', 'wait');
                $('.app').addClass('light-blur');
                $('#ajax-progress-indicator').fadeIn();
                $.ajax({
                    url: Slim.Router.pathFor('platforms.districts.groups.bulk_edit.post', {
                        platform_id: me.platformId,
                        district_joint_guid: me.districtJointGuid,
                    }),
                    dataType: 'json',
                    method: 'POST',
                    data,
                    async: true,
                })
                    .done((responseData) => {
                        if (typeof responseData.meta.failures !== 'undefined' && responseData.meta.failures > 0) {
                            $.each(responseData.data.failure, (i, message) => {
                                me.bulkEditResponseModal
                                    .find('.modal-body')
                                    .append(
                                        `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${message}</div>`,
                                    );
                            });
                            $.each(responseData.data.success, (i, message) => {
                                me.bulkEditResponseModal
                                    .find('.modal-body')
                                    .append(
                                        `<div class="alert alert-success" role="alert"><i class="fa fa-thumbs-up" aria-hidden="true"></i> ${message}</div>`,
                                    );
                            });
                            me.bulkEditResponseModal.modal({
                                backdrop: 'static',
                                keyboard: false,
                            });
                        }
                    })
                    .fail((jqXHR, textStatus, errorThrown) => {
                        if (+jqXHR.status === 400) {
                            me.bulkEditResponseModal
                                .find('.modal-body')
                                .prepend(
                                    `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${jqXHR.responseJSON.message}</div>`,
                                );
                        } else {
                            me.bulkEditResponseModal
                                .find('.modal-body')
                                .prepend(
                                    `<div class="alert alert-danger" role="alert"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> ${errorThrown}</div>`,
                                );
                        }
                        me.bulkEditResponseModal.modal({
                            backdrop: 'static',
                            keyboard: false,
                        });
                    })
                    .always(() => {
                        $('body').css('cursor', 'default');
                        $('.app').removeClass('light-blur');
                        $('#ajax-progress-indicator').fadeOut();
                        // if we deleted the groups, clear out the selections array
                        if (action === 'delete') {
                            me.selections = [];
                        }
                        me.updateSelectedGroupsCount();
                        me.disableBulkEditMode();
                        me.groupsTable.bootstrapTable('refresh', {
                            silent: true,
                        });
                        me.bulkEditModal.modal('hide');
                    });

                me.bulkEditEditButton.prop('disabled', false);
                me.updateSelectedGroupsCount();
                return false;
            });

            cancelButton.on('click', () => {
                $('#bulk-edit-modal .modal-body .alert').remove();
                $('#bulk-edit-modal .modal-body input').removeClass('is-invalid').removeClass('is-valid');
                me.bulkEditEditButton.prop('disabled', false);
                me.updateSelectedGroupsCount();
            });

            const modalFooter = $('<div></div>');
            modalFooter.append(cancelButton);
            modalFooter.append(saveButton);

            if (me.bulkEditModal == null) {
                me.bulkEditModal = VjsAdmin.Modal.create({
                    id: 'bulk-edit-modal',
                    title: `Bulk Edit <span class="selected-groups-count">${me.selections.length} Groups</span>`,
                    body: bulkEditGroupsForm,
                    footer: modalFooter,
                    no_close: true,
                    onShown() {
                        me.updateSelectedGroupsCount();
                        $('#bulk-edit-action').on('change', (e) => {
                            $('#bulk-edit-modal .modal-body .alert').remove();
                            const action = e.target.value;
                            $('#custom-form-fields')
                                .html('')
                                .append($(`#bulk-edit-groups-${action}`).html());
                            if (action === '') {
                                $('#custom-form-fields-container').hide();
                            } else {
                                $('#custom-form-fields-container').show();
                            }
                        });
                    },
                });
            }

            const closeButton = $('<button type="button" class="btn btn-hollow-dark-gray" data-dismiss="modal">Close</button>');

            if (me.bulkEditResponseModal == null) {
                me.bulkEditResponseModal = VjsAdmin.Modal.create({
                    id: 'bulk-edit-response-modal',
                    title: 'Bulk Edit Results',
                    body: '',
                    footer: closeButton,
                    onHidden() {
                        $('#bulk-edit-response-modal .modal-body .alert').remove();
                    },
                });
            }

            me.groupsTable.on('check.bs.table check-all.bs.table uncheck.bs.table uncheck-all.bs.table', (e, rows) => {
                const groupIds = $.map(!$.isArray(rows) ? [rows] : rows, (row) => row.group_id);
                if (e.type === 'check' || e.type === 'check-all') {
                    if (groupIds.length + me.selections.length > me.bulkDeleteMax) {
                        window.alert('You have reached the max # of groups to bulk delete at one time!');
                        me.groupsTable.bootstrapTable('uncheckBy', {
                            field: 'user_id',
                            values: _.difference(groupIds, me.selections),
                        });
                        return false;
                    }
                }
                const func = $.inArray(e.type, ['check', 'check-all']) > -1 ? 'union' : 'difference';
                me.selections = _[func](me.selections, groupIds);
                me.updateSelectedGroupsCount();
            });

            me.addButtons();
        }
    };

    me.updateSelectedGroupsCount = () => {
        $('.selected-groups-count').text(`${me.selections.length} Group${me.selections.length === 1 ? '' : 's'}`);
    };

    me.enableBulkEditMode = () => {
        me.updateSelectedGroupsCount();
        me.bulkEditEnableButton.hide();
        me.bulkEditEditButton.show();
        me.bulkEditEditButton.tooltip('show');
        me.bulkEditDoneButton.show();
        me.groupsTable.bootstrapTable('showColumn', 'checkbox');
    };

    me.disableBulkEditMode = () => {
        me.updateSelectedGroupsCount();
        me.bulkEditEnableButton.show();
        me.bulkEditEditButton.hide();
        me.bulkEditDoneButton.hide();
        me.groupsTable.bootstrapTable('hideColumn', 'checkbox');
    };

    me.addButtons = () => {
        me.groupsTable.closest('.bootstrap-table').find('.fixed-table-toolbar .columns-right').after(me.bulkEditButtons);
    };

    return {
        init: me.init,
    };
}());
